import { computeTitleFontSize, TITLE_SPACING } from '../../utils/chartLayout';
import { chartFonts } from '../../utils/chartFonts';

/**
 * Shared chart title component.
 * Auto-scales font size to fit available width. Never truncates with ellipsis.
 *
 * Props:
 *   title        – the title string (renders nothing if falsy)
 *   chartWidth   – total chart width in px
 *   marginLeft   – left margin so title aligns with the plot area
 *   theme        – resolved theme object (titleColor, fontHeading)
 *   centered     – if true, centers title across full width (e.g. radar)
 */
function ChartTitle({ title, chartWidth, marginLeft, marginRight = 20, theme }) {
  if (!title) return null;

  const fontSize = computeTitleFontSize(title, chartWidth, marginLeft);
  const fonts = chartFonts(theme);

  return (
    <div style={{
      position: 'absolute',
      top: TITLE_SPACING.topInset,
      left: marginLeft,
      width: chartWidth - marginLeft - marginRight,
      textAlign: 'center',
      fontSize,
      fontWeight: 400,
      color: theme.titleColor || theme.foreground || '#000',
      fontFamily: fonts.heading,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    }}>
      {title}
    </div>
  );
}

export default ChartTitle;
